import React from 'react';

import { Result, Button } from 'antd';

// import { useTheme } from 'utils/Theme';
import { NotFoundGeneratedProps } from './NotFound.props';
import { Container } from './NotFound.style';

const NotFoundView = (props: NotFoundGeneratedProps): JSX.Element => {
  // const theme = useTheme();
  return (
    <Container>
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      />
    </Container>
  );
};

export default NotFoundView;
